'use client';

import Image from 'next/image';
import { GlowIcon, GlowImage, Icons } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ObjectHelpers } from '@headless-workspace/utils';
import {
    isMySephoraCard,
    isSephoraCard,
    isSephoraUnlimitedCard,
    UserMySephoraCard,
    UserSephoraCard,
    UserSephoraCardType,
    UserSephoraCardUnlimited,
} from '../../../server/lib/customer/CustomerValue';

type FidIconProps = {
    userCard?: UserSephoraCardType;
    isMySephoraActivated: boolean;
    isRequired?: boolean;
};

const FIDS = {
    [UserSephoraCard.White]: Icons.WhiteFid,
    [UserSephoraCard.Black]: Icons.BlackFid,
    [UserSephoraCard.Gold]: Icons.GoldFid,
    [UserSephoraCardUnlimited.Standard]: Icons.BlackFid,
    [UserSephoraCardUnlimited.Star]: Icons.GoldFid,
};

const MY_SEPHORA_FID_ICONS = {
    [UserMySephoraCard.Bronze]: Icons.MySephoraBronzeFid,
    [UserMySephoraCard.Silver]: Icons.MySephoraSilverFid,
    [UserMySephoraCard.Gold]: Icons.MySephoraGoldFid,
};

const FID_ICON_SIZE = 32;

export const FidIcon: Component<FidIconProps> = ({ userCard, isMySephoraActivated, isRequired = false }) => {
    const hasNoFid = !userCard || userCard === UserSephoraCard.PreBuy;

    // Display default fid icon for a user not logged in or a user without a loyalty card
    if (isRequired && hasNoFid) {
        return isMySephoraActivated ? (
            <GlowImage
                image={ObjectHelpers.createImageWithSrc('/images/mySephoraBlackFid.gif')}
                height={FID_ICON_SIZE}
                width={FID_ICON_SIZE}
                TagName={Image}
            />
        ) : (
            <GlowIcon Icon={Icons.MultiFid} type={'large'} />
        );
    }

    // Don't display fid icon when user doesn't have a loyalty card or not connected
    if (hasNoFid) {
        return null;
    }

    // Display My Sephora fid icon if My Sephora program is activated and the user has a My Sephora card
    if (isMySephoraActivated) {
        if (isMySephoraCard(userCard)) {
            return <GlowIcon Icon={MY_SEPHORA_FID_ICONS[userCard]} type={'large'} />;
        }
        return null;
    }

    // Display Sephora fid icon for regular Sephora cards
    if (isSephoraCard(userCard) || isSephoraUnlimitedCard(userCard)) {
        return <GlowIcon Icon={FIDS[userCard]} type={'large'} />;
    }

    return null;
};
